import { type FC, lazy, Suspense } from "react"

import type { LandingPageTextBlock } from "@forento/core/models/landing"
import { landingPageTextSizeClasses } from "@forento/ui/utilities/landingTextSize"
import { cn } from "@forento/ui/utilities/tailwind"

const RichTextPreview = lazy(() => import("@forento/ui/components/RichTextPreview"))

const textClassName =
	"text-landing-foreground-muted [&>a]:font-medium [&>a]:text-landing-foreground [&>a]:underline [&>a]:underline-offset-4 [&>code]:rounded [&>code]:bg-landing-surface-muted [&>code]:px-1.5 [&>code]:py-0.5 [&>code]:font-mono [&>code]:text-landing-foreground [&>code]:text-sm [&>h1:first-child]:mt-0 [&>h1]:mt-8 [&>h1]:mb-4 [&>h1]:font-bold [&>h1]:text-landing-foreground [&>h1]:tracking-tight [&>h2]:mt-8 [&>h2]:mb-4 [&>h2]:font-semibold [&>h2]:text-landing-foreground [&>h2]:tracking-tight [&>h3]:mt-6 [&>h3]:mb-3 [&>h3]:font-semibold [&>h3]:text-landing-foreground [&>li]:text-landing-foreground-muted [&>ol]:mb-6 [&>ol]:list-decimal [&>ol]:space-y-2 [&>ol]:pl-6 [&>p:last-child]:mb-0 [&>p]:mb-6 [&>strong]:font-semibold [&>strong]:text-landing-foreground [&>ul]:mb-6 [&>ul]:list-disc [&>ul]:space-y-2 [&>ul]:pl-6"

type Props = {
	block: LandingPageTextBlock
}

const TextBlockPreview: FC<Props> = ({ block }) => {
	return (
		<section className="px-6 pt-16 pb-0 sm:pt-20 lg:px-8">
			<div className="mx-auto max-w-3xl">
				<Suspense>
					<RichTextPreview
						value={block.content.text}
						fallback="Text content"
						className={cn(textClassName, landingPageTextSizeClasses[block.content.size])}
					/>
				</Suspense>
			</div>
		</section>
	)
}

export default TextBlockPreview
